<hr class="footer__divider" />
<div class="footer__actions" *ngrxLet="vm$ as vm">
  @if (
    vm.isFinalStep &&
    ((multipleRegistrations$ | async) === undefined ||
      (multipleRegistrations$ | async)?.enabled === true)
  ) {
    <button
      type="button"
      se-fe-button
      (click)="registerAnotherPersonClick.emit()"
      class="register-another">
      {{
        (multipleRegistrations$ | async)?.buttonLabel ||
          'Register another person'
      }}
    </button>
  }
  @if (vm.showContinueToCheckoutButton) {
    <button
      #continueEle
      type="button"
      se-fe-button
      class="complete"
      (click)="continueToCheckoutClick.emit()">
      Continue to checkout
    </button>
  }
  @if (!vm.showContinueToCheckoutButton) {
    <a
      #continueEle
      se-fe-button
      class="footer__continue continue"
      (click)="continue(vm.continueLink ?? '')">
      Continue
    </a>
  }
</div>
